import { Box, BoxProps, Flex, FlexProps } from '@chakra-ui/react'

export const ScrollableBodyContainer = ({
  header,
  footer,
  body,
  flexProps,
  bodyProps,
}: {
  header?: React.ReactNode
  footer?: React.ReactNode
  body: React.ReactNode
  flexProps?: FlexProps
  bodyProps?: BoxProps
}) => (
  <Flex h="100%" w="100%" flexFlow="column" {...flexProps}>
    {header}
    <Box flex={1} minH={0} w="100%" overflowY="auto" {...bodyProps}>
      {body}
    </Box>
    {footer}
  </Flex>
)
